import React, {useEffect, useMemo, useState} from "react"
import {PolygonShapeType, ShapeFeatureType, ShapeType} from "../../../types/shape"
import {ConfigurationsType} from "../../../types/configurations"
import {
    AllInterferometricStacksType,
    ProductImageStacType,
    SearchResultElementType,
    SearchResultsType,
} from "../../../types/product"
import {QuicklookPreviewType} from "../../../types/geoMap"
import {getAllShapeFeaturesShownInMap, getSceneShapeFeatureProps} from "../../../helpers/shapeFeaturesListHelper"
import ShapeFeature, {ShapeFeaturePropsType} from "./ShapeFeature"
import {getSearchFormValuesByState, isCutSceneAvailableByStacItem} from "../../../helpers/configurationHelper";
import product from "../../shared/search-results/Product";
import {removeSearchResultDetailsAction, storeSearchResultDetailsAction} from "../../../state/application/actions";
import {
    openSearchResultDetailsDispatchAction,
    updateSelectedProductsDispatchAction
} from "../../../state/product/dispatchActions";
import {
    addCutScene, addLoadingScene, addSceneToCut, removeLoadingScene,
    replaceCutScenes, replaceLoadingScenes,
    replaceScenesToCut,
    updateQuicklookPreviewsAction
} from "../../../state/geoMap/actions";
import {connect} from "react-redux"
import {getScenesInformationFrom} from "../../../helpers/cutSceneHelper";
import {errorToastNotification} from "../../../helpers/toastNotificationHelper";
import translations from "../../../translations";
import {getErrorMessageFrom, getFramingErrorMessageFrom} from "../../../helpers/errorsHelper";
import {AppParametersType} from "../../../types/app";

interface PropsType {
    configurations: ConfigurationsType
    formValues: any
    selectedProducts: ProductImageStacType[]
    searchResultDetails: any
    quicklookPreviews: QuicklookPreviewType[]
    searchResults: SearchResultsType
    allInterferometricStacks: AllInterferometricStacksType
    onShapeClick: (element: SearchResultElementType) => {}
    isKml: boolean,
    cutscenes,
    scenesToCut,
    loadingScenes,
    isFramingViewActive,
    addCutSceneActionHandler,
    updateCutScenesActionHandler,
    addSceneToCutActionHandler,
    updateScenesToCutActionHandler,
    addLoadingSceneActionHandler,
    updateLoadingScenesActionHandler,
    removeLoadingScenesActionHandler,
    language,
    appParamters: AppParametersType,
    lastShape,
    lastShapeAoi
}

const ShapeFeaturesList = (props: PropsType) => {
    const {
        configurations,
        formValues,
        selectedProducts,
        searchResultDetails,
        quicklookPreviews,
        searchResults,
        allInterferometricStacks,
        onShapeClick,
        isKml,
        cutscenes,
        scenesToCut,
        loadingScenes,
        isFramingViewActive,
        addCutSceneActionHandler,
        updateCutScenesActionHandler,
        addSceneToCutActionHandler,
        updateScenesToCutActionHandler,
        addLoadingSceneActionHandler,
        updateLoadingScenesActionHandler,
        removeLoadingScenesActionHandler,
        language,
        appParamters,
        lastShape,
        lastShapeAoi
    } = props

    const [shapeFeaturesShownInMap, setShapeFeaturesShownInMap] = useState<ShapeFeaturePropsType[]>([]);

    // questo useMemo si occupa di invocare il Framing per tagliare le scene e alimentare la variabile cutscenes
    useMemo(() => {
        // determino le scenesToCut (quelle che non sono già in cutscenes) utilizzabili
        let usableScenesToCut = scenesToCut.filter((sceneToCut) => !cutscenes.some((cutscene) => cutscene.id === sceneToCut.id));
        usableScenesToCut = usableScenesToCut.filter((sceneToCut) => (!lastShapeAoi && sceneToCut.aoi_added_on_time === null) || (lastShapeAoi && sceneToCut.aoi_added_on_time === lastShapeAoi.added_on_time));
        // pulisco le cutscene non più valide
        const hasUnusableScenesToCut = usableScenesToCut.length !== scenesToCut.length;
        if (hasUnusableScenesToCut) {
            updateScenesToCutActionHandler(usableScenesToCut);
        }

        const scenesToLoad = usableScenesToCut.filter((sceneToCut) => !loadingScenes.some((loadingScene) => loadingScene.id === sceneToCut.id));
        scenesToLoad.forEach((sceneToCut) => {
            // aggiungo la scena in caricamento
            const newLoadingScene = {
                id: sceneToCut.product.id,
                aoi_added_on_time: lastShapeAoi ? lastShapeAoi.added_on_time : null,
            }
            addLoadingSceneActionHandler(newLoadingScene);
            // invoco il framing tramite API
            getScenesInformationFrom(lastShapeAoi, sceneToCut.product as ProductImageStacType).then(result => {
                const retrievedScenes = result && result.data ? result.data : null;
                if (retrievedScenes && retrievedScenes.features && retrievedScenes.features.length) {
                    // aggiorno le cutscenes salvate, inserendo le scene appena ottenute
                    const newCutscene = {
                        id: sceneToCut.product.id,
                        scenes: retrievedScenes.features,
                        aoi_added_on_time: lastShapeAoi ? lastShapeAoi.added_on_time : null,
                    }
                    addCutSceneActionHandler(newCutscene);
                }
            }).catch(e => {
                errorToastNotification(getFramingErrorMessageFrom(e));
            }).finally(() => {
                // rimuovo la loading scene il cui caricamento è terminato
                removeLoadingScenesActionHandler(sceneToCut.id);
            });
        });
    }, [scenesToCut]);

    // questo useMemo si occupa di valutare le nuove scene da tagliare
    useMemo(() => {
        // determino le usableCutscenes (scarto quelle non valide per il cambio AOI)
        const usableCutscenes = cutscenes.filter((cutscene) => (!lastShapeAoi && cutscene.aoi_added_on_time === null) || (lastShapeAoi && cutscene.aoi_added_on_time === lastShapeAoi.added_on_time));
        // pulisco le cutscene non più valide
        const hasUnusableCutscenes = usableCutscenes.length !== cutscenes.length;
        if (hasUnusableCutscenes) {
            updateCutScenesActionHandler(usableCutscenes);
        }

        // if (selectedProducts && selectedProducts.length) {
        //     console.log(selectedProducts);
        //     debugger;
        // }
        // if (searchResultDetails) {
        //     console.log(searchResultDetails);
        //     debugger;
        // }

        // determino le scenesToCut (quelle che non sono già in cutscenes) utilizzabili
        let usableScenesToCut = scenesToCut.filter((sceneToCut) => !cutscenes.some((cutscene) => cutscene.id === sceneToCut.id));
        usableScenesToCut = scenesToCut.filter((sceneToCut) => (!lastShapeAoi && sceneToCut.aoi_added_on_time === null) || (lastShapeAoi && sceneToCut.aoi_added_on_time === lastShapeAoi.added_on_time));
        // pulisco le cutscene non più valide
        const hasUnusableScenesToCut = usableScenesToCut.length !== scenesToCut.length;
        if (hasUnusableScenesToCut) {
            updateScenesToCutActionHandler(usableScenesToCut);
        }

        // recupero le shape features di base da mostrare in mappa...
        let updatedShapeFeaturesShownInMap: ShapeFeaturePropsType[] = getAllShapeFeaturesShownInMap(
            configurations,
            appParamters,
            formValues,
            selectedProducts,
            searchResultDetails,
            lastShape,
            quicklookPreviews,
            searchResults,
            allInterferometricStacks,
            onShapeClick,
            isKml
        );
        // ...le resetto di nuovo per farle disegnare
        setShapeFeaturesShownInMap(updatedShapeFeaturesShownInMap);

        // recupero gli elementi selezionati per le scene (questo oggetto ne garantisce l'unicità)
        let productsToIterate: any = {};
        let stacksToIterate: any = {};
        let productList: any[] = [];
        productList = productList.concat(selectedProducts);

        // vado a recuperare le cutscenes e relative scene da disegnare
        if (isFramingViewActive || searchResultDetails) { // se la framing view è attiva oppure sono in details
            productList.forEach((product) => {
                // se è una scena da tagliare...
                if (isCutSceneAvailableByStacItem(configurations, formValues, lastShapeAoi, product) && !productsToIterate[product.id as string]) {
                    // valuto se la questo prodotto è parte di uno stack già disegnato
                    const stackSceneAlreadyDrawn = !!(product.properties.interferometric_stack_id && stacksToIterate[product.properties.interferometric_stack_id]);
                    productsToIterate[product.id as string] = product;
                    // cerco la scena tra quelle già tagliate e valide, con lo stesso id della shapeFeature attuale
                    let foundScene: any = usableCutscenes.find((cutscene: any) => cutscene.id === product.id);
                    if (!foundScene) { // non c'è, devo recuperarla
                        const sceneIsLoading = loadingScenes.some((loadingScene) => loadingScene.id === product.id);
                        const sceneIsToCut = usableScenesToCut.some((sceneToCut) => sceneToCut.id === product.id);
                        if (!sceneIsLoading && !sceneIsToCut) {
                            // aggiungo la scena a scenesToCut, così che venga recuperata tramite API (in altro useMemo)
                            const newSceneToCut = {
                                id: product.id,
                                product,
                                aoi_added_on_time: lastShapeAoi ? lastShapeAoi.added_on_time : null,
                            }
                            addSceneToCutActionHandler(newSceneToCut);
                        }
                    } else if (!stackSceneAlreadyDrawn) {
                        // è tra quella recuperata, la posso disegnare su mappa
                        const scenesAsShapeFeatureProps = foundScene.scenes.map((turfShape: ShapeFeatureType, index) => {
                            return ({
                                shapeFeature: turfShape,
                                shapeFeatureProps: getSceneShapeFeatureProps({key: `${product.id}-scene-${index}`}),
                            });
                        });
                        // se è un prodotto contenuto in uno stack lo salvo tra quelli disegnati
                        if (product.properties.interferometric_stack_id) {
                            stacksToIterate[product.properties.interferometric_stack_id] = product;
                        }
                        // le aggiungo in mappa
                        updatedShapeFeaturesShownInMap = updatedShapeFeaturesShownInMap.concat(scenesAsShapeFeatureProps);
                        setShapeFeaturesShownInMap(updatedShapeFeaturesShownInMap);
                    }
                } else {
                    // sarà una AOI oppure una quicklook (altro?) che hanno già tutto il necessario per essere disegnate e lo saranno subito (in modo sincrono)
                }
            });
        }
    }, [isFramingViewActive, lastShapeAoi, cutscenes, selectedProducts, searchResultDetails, searchResults, allInterferometricStacks]);

    return (
        <>
            {shapeFeaturesShownInMap.map(({shapeFeature, shapeFeatureProps}, index) => (
                <ShapeFeature
                    key={`shape-${index}`}
                    shapeFeature={shapeFeature}
                    {...(((lastShapeAoi as any)?.inscribedPolygon)
                        ? {inscribedPolygon: (lastShapeAoi as any)?.inscribedPolygon}
                        : {})}
                    shapeFeatureProps={shapeFeatureProps}
                />
            ))}
        </>
    )
}


const mapStateToProps = (state) => ({
    cutscenes: state.geoMap.availableCutScenes,
    scenesToCut: state.geoMap.availableScenesToCut,
    loadingScenes: state.geoMap.availableLoadingScenes,
    language: state.application.appParameters.language,
    appParameters: state.application.appParameters,
    lastShapeAoi: state.geoMap.lastShape,
    isFramingViewActive: state.product.isFramingViewActive,
});

const mapDispatchToProps = (dispatch) => ({
    addSceneToCutActionHandler: (sceneToCut) => dispatch(addSceneToCut(sceneToCut)),
    updateScenesToCutActionHandler: (scenesToCut) => dispatch(replaceScenesToCut(scenesToCut)),
    addCutSceneActionHandler: (cutscene) => dispatch(addCutScene(cutscene)),
    updateCutScenesActionHandler: (cutscenes) => dispatch(replaceCutScenes(cutscenes)),
    addLoadingSceneActionHandler: (loadingScene) => dispatch(addLoadingScene(loadingScene)),
    updateLoadingScenesActionHandler: (loadingScenes) => dispatch(replaceLoadingScenes(loadingScenes)),
    removeLoadingScenesActionHandler: (loadingSceneId) => dispatch(removeLoadingScene(loadingSceneId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShapeFeaturesList)
